import { render, staticRenderFns } from "./VirtualEmployee.vue?vue&type=template&id=b207fc5c"
import script from "./VirtualEmployee.vue?vue&type=script&lang=js"
export * from "./VirtualEmployee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports